// Published current and effective 1/1/27 fares: https://www.caltrain.com/fares
// California midnight, independent of the browser's time zone or service day.
export const FARE_CHANGE_TIME = Date.parse("2027-01-01T00:00:00-08:00");

const current = {
  adult: [4, 6.25, 8.5, 10.75, 13, 15.25],
  discounted: [2, 3, 4, 5, 6, 7],
  youth: [1, 1, 1, 1, 1, 1],
  monthly: [96, 150, 204, 258, 312, 366],
  monthlyDiscount: [48, 72, 96, 120, 144, 168],
  monthlyYouth: [24, 24, 24, 24, 24, 24],
};

const january2027 = {
  adult: [4, 6.5, 9, 11.5, 14, 16.5],
  discounted: [2, 3.25, 4.5, 5.75, 7, 8.25],
  youth: [1, 1, 1, 1, 1, 1],
  monthly: [96, 156, 216, 276, 336, 396],
  monthlyDiscount: [48, 78, 108, 138, 168, 198],
  monthlyYouth: [24, 24, 24, 24, 24, 24],
};

export function getPricesForZones(zones, date = new Date()) {
  if (!Number.isInteger(zones) || zones < 1 || zones > 6) return [];
  const prices = date.getTime() >= FARE_CHANGE_TIME ? january2027 : current;
  const index = zones - 1;
  return [
    { type: "Adult", price: prices.adult[index] },
    { type: "Discounted", price: prices.discounted[index] },
    { type: "Youth", price: prices.youth[index] },
    { type: "Monthly Pass", price: prices.monthly[index] },
    { type: "Monthly Pass (Discounted)", price: prices.monthlyDiscount[index] },
    { type: "Monthly Pass (Youth)", price: prices.monthlyYouth[index] },
  ];
}
